import i18n from 'i18n-js';

import ar from './locales/ar.json';
import en from './locales/en.json';
import de from './locales/de.json';
import fa from './locales/fa.json';
import ku from './locales/ku.json';

i18n.defaultLocale = 'en';
i18n.locale = 'en';
i18n.fallbacks = true;
i18n.translations = {fa,en, de, ar,ku};

export default i18n;